export default "__VITE_ASSET__41447798__"